import { useQuery } from '@tanstack/react-query';
import { solicitacaoService } from '../../services/solicitacaoService';
import { SI_SOLICITACOES_QUERY_KEYS } from './useSolicitacoesQuery';

export function useSolicitacaoQuery(id: string | undefined) {
  return useQuery({
    queryKey: SI_SOLICITACOES_QUERY_KEYS.detalhe(id ?? ''),
    queryFn: () => solicitacaoService.getById(id as string),
    enabled: Boolean(id),
  });
}
